import React from 'react';
import styled from 'styled-components';
import { VenueType } from '../../../shared/enum/EnumRepository';
import { VenueFilterData } from '../../../shared/dto/EntityRepository';
import { UniversalCheckbox } from '../../../shared/component/UniversalCheckbox';
import { useLanguageStore } from '../../../shared/store/languageStore';
import { getVenueTypeLabel, getVenueFilterLabel } from '../../../shared/util/venueTypeLabel';

interface FilterStationVenueTypeProps {
  currentFilter: VenueFilterData;
  setCurrentFilter: (filter: VenueFilterData) => void;
}

const FilterStationVenueType: React.FC<FilterStationVenueTypeProps> = ({
  currentFilter,
  setCurrentFilter,
}) => {
  const language = useLanguageStore((s) => s.language);
  const types = Object.values(VenueType);
  const typeAll = types.every((type) => currentFilter.venueType[type]);

  const handleTypeChange = (type: VenueType) => {
    setCurrentFilter({
      ...currentFilter,
      venueType: {
        ...currentFilter.venueType,
        [type]: !currentFilter.venueType[type],
      },
    });
  };

  const handleTypeChangeAll = () => {
    const next = !typeAll;
    setCurrentFilter({
      ...currentFilter,
      venueType: types.reduce((acc, type) => {
        acc[type] = next;
        return acc;
      }, {} as { [key in VenueType]: boolean }),
    });
  };

  return (
    <TypeFilterComp>
      <TypeSubTitle>{getVenueFilterLabel('TYPE', language)}</TypeSubTitle>
      <TypeFilterList>
        {types.map((type) => (
          <CheckboxComp key={type}>
            <UniversalCheckbox
              checked={currentFilter.venueType[type]}
              onChange={() => handleTypeChange(type)}
            />
            {getVenueTypeLabel(type, language)}
          </CheckboxComp>
        ))}
        <CheckboxComp>
          <UniversalCheckbox
            checked={typeAll}
            onChange={handleTypeChangeAll}
          />
          Select ALL
        </CheckboxComp>
      </TypeFilterList>
    </TypeFilterComp>
  );
};

export default FilterStationVenueType;

const TypeSubTitle = styled.div`
  margin-bottom: 1.2vh;
  ${({ theme }) => theme.typography.Body_03_1};
`;

const TypeFilterComp = styled.div`
  display: flex;
  flex-direction: column;
`;

const TypeFilterList = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  column-gap: 20px;
  row-gap: 4px;
`;

const CheckboxComp = styled.label`
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-bottom: 4px;
  user-select: none;
  ${({ theme }) => theme.typography.Body_04};
  color: ${({ theme }) => theme.colors.color_Gray_03};
`;
